export default __webpack_public_path__ + "files/ac880b6000c186147b356a30492d409f.png";